import Vue from 'vue';
import * as Sentry from '@sentry/browser';

if (process.env.NODE_ENV === 'production') {
    Sentry.init({
        dsn: 'https://8a09e733d1724ad8b33bac1692cc40fb@sentry.io/1295353',
        debug: process.env.NODE_ENV === 'development',
        environment: process.env.VUE_APP_ENV || process.env.NODE_ENV,
        integrations: [new Sentry.Integrations.Vue({ Vue })],
        // beforeSend: (event) => {
        //     if (event.exception) {
        //         Sentry.showReportDialog();
        //     }
        //
        //     return event;
        // },
    });
}
